import { atom } from 'jotai'
import type { AnalysisResultResponse } from '@/api/queries/analysis'

export const analysisResultDataAtom = atom<AnalysisResultResponse | null>(null)
